import "core-js/modules/esnext.global-this.js";
export var File = globalThis.File;
export var Blob = globalThis.Blob;